import type { EditorConfig, LexicalEditor, LexicalNode, SerializedTextNode, Spread } from 'lexical';
import { TextNode } from 'lexical';

const SceneNumberNodeLexicalType = 'scene-number-node'; // DO NOT CHANGE THIS OR ELSE OLD TRANSCRIPTS WILL NOT RENDER
export type SerializedSceneNumberNode = Spread<
    {
        type: typeof SceneNumberNodeLexicalType;
    },
    SerializedTextNode
>;
export class SceneNumberNode extends TextNode {
    static override getType() {
        return SceneNumberNodeLexicalType;
    }

    static override clone(node: SceneNumberNode): SceneNumberNode {
        return new SceneNumberNode(node.__text, node.__key);
    }

    override createDOM(config: EditorConfig, editor?: LexicalEditor): HTMLElement {
        const sceneNumber = document.createElement('span');
        sceneNumber.className = 'scene-number';
        sceneNumber.contentEditable = 'false'; // do not allow the user to edit the scene number
        sceneNumber.textContent = this.__text;
        return sceneNumber;
    }

    override exportJSON(): SerializedSceneNumberNode {
        return {
            ...super.exportJSON(),
            type: SceneNumberNodeLexicalType,
        };
    }

    static override importJSON(serializedNode: SerializedSceneNumberNode): SceneNumberNode {
        return $createSceneNumberNode(parseInt(serializedNode.text));
    }

    override canInsertTextBefore(): boolean {
        // if the cursor is right next to the scene number node,
        // and the user begins typing, text should not go into the
        // scene number node
        return false;
    }

    override canInsertTextAfter(): boolean {
        // if the cursor is right next to the scene number node,
        // and the user begins typing, text should not go into the
        // scene number node
        return false;
    }
}

export const $createSceneNumberNode = (sceneNumber: number): SceneNumberNode => {
    return new SceneNumberNode(sceneNumber.toString());
};

export const $isSceneNumberNode = (node: LexicalNode): node is SceneNumberNode => {
    return node instanceof SceneNumberNode;
};
